import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useUser } from "../hooks/useUser";
import Loader from "./Spinner.component";

function ProtectedRoute({ children }) {
  const navigate = useNavigate();

  const { isLoading, user } = useUser();

  useEffect(
    function () {
      if (!user && !isLoading) navigate("/login");
    },
    [user, isLoading, navigate]
  );

  if (isLoading) return <Loader />;

  if (user) return children;
}

export default ProtectedRoute;
